import { Cpa } from './tipologiche/cpa';
import { Iva } from './tipologiche/iva';

export class CostoGestioneLiquidato {
  diritti: number;
  onorari: number;
  compenso: number;
  cpa: Cpa;
  iva: Iva;
  flagRitenutaAcconto: boolean;
  speseGenerali: number;
  speseGeneraliValore: number;
  id: string;
  speseLiquidate:number;
  irap: number;
  oneriRiflessi: number;
  speseMarcheNotifica: number;
  art96CPC: number;
  f23: number;
  risarcimento: number;
}
